import { useNavigate } from "react-router-dom";

export const useHandleBack = (fallback: string) => {
    const navigate = useNavigate();

    const goBack = () => {
        // Check if we're navigating back to template list and restore pagination from sessionStorage
        if (fallback === "/template") {
            const savedPage = sessionStorage.getItem("templatePage");
            if (savedPage) {
                navigate(`${fallback}?page_template=${savedPage}`);
                return;
            }
        }
        
        // Check if we're navigating back to item list and restore pagination from sessionStorage
        if (fallback === "/item") {
            const savedPage = sessionStorage.getItem("itemPage");
            if (savedPage) {
                navigate(`${fallback}?page_item=${savedPage}`);
                return;
            }
        }
        
        // Check if we're navigating back to quotation list and restore pagination and tab from sessionStorage
        if (fallback === "/quotation") {
            const savedQuotationPage = sessionStorage.getItem("quotationPage");
            const savedTrashPage = sessionStorage.getItem("trashPage");
            const savedTab = sessionStorage.getItem("QuotationContainerTab");
            
            // If we have a saved tab, use it; otherwise default to tab 1
            const tabToUse = savedTab || "1";
            
            // Build URL with parameters if they exist
            const params = new URLSearchParams();
            if (savedQuotationPage) params.append("page_quotation", savedQuotationPage);
            if (savedTrashPage) params.append("page_trash", savedTrashPage);
            params.append("tab", tabToUse);
            
            navigate(`${fallback}?${params.toString()}`);
            return;
        }
        
        // Check if we're navigating back to category list and restore pagination from sessionStorage
        if (fallback === "/category") {
            const savedPage = sessionStorage.getItem("categoryPage");
            if (savedPage) {
                navigate(`${fallback}?page_category=${savedPage}`);
                return;
            }
        }
        
        // Check if we're navigating back to gst list and restore pagination from sessionStorage
        if (fallback === "/gst") {
            const savedPage = sessionStorage.getItem("gstPage");
            if (savedPage) {
                navigate(`${fallback}?page_gst=${savedPage}`);
                return;
            }
        }
        
        // Check if we're navigating back to customer list and restore pagination from sessionStorage
        if (fallback === "/customer") {
            const savedPage = sessionStorage.getItem("customerPage");
            if (savedPage) {
                navigate(`${fallback}?page_customer=${savedPage}`);
                return;
            }
        }
        
        // Check if we're navigating back to users list and restore pagination from sessionStorage
        if (fallback === "/user-list") {
            const savedPage = sessionStorage.getItem("usersPage");
            if (savedPage) {
                navigate(`${fallback}?page_users=${savedPage}`);
                return;
            }
        }
        
        if (document.referrer && document.referrer.includes(window.location.host)) {
            navigate(-1);
        } else {
            navigate(fallback);
        }
    };

    return goBack;
};
